module.exports = __webpack_public_path__ + "static/media/C_E02.da54bace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_E02.png
// module id = 70
// module chunks = 0